import { assign as internalAssign } from "./lib/assign";
import { assignable } from "./lib/assignable";

/**
 * Deep object assignment
 *
 * @example assign({hash: {a: 1}}, {hash: {b: 2, c: 0}}, {hash: {c: 3}}) // {hash: {a: 1, b:2, c: 3}}
 */
export function assign(target: any, ...others: any[]): any {
	assignable(target) &&
		others.forEach((other) => internalAssign(target, other));

	return target;
}
